<template>
  <div v-loading="isLoading" class="mx-auto fs-16">
    <div>
      <div class="w-full flex flex-col md:flex-row justify-between gap-2">
        <div class="flex-1 flex flex-col gap-2">
          <div class="flex gap-2">
            <div style="color:#20409b" class="fs-20 font-bold">{{getDataLang().title || '' }}</div>
            <p class="fs-24 fw-600 max-line-2 txt-pri title mb-0 labels">
              <span
                class="fs-14 text-white"
                :class="getStatus(sessionData.status).class"
              >{{ getStatus(sessionData.status).text }}</span>
            </p>
          </div>
          <div
            v-if="sessionData.circle_schedule_speakers && sessionData.circle_schedule_speakers.length"
            class="flex items-center flex-wrap gap-2"
          >
            <span>{{ $t('conference.lbl_speaker') }}:</span>
            <div class="flex gap-1">
              <div v-for="speaker in sessionData.circle_schedule_speakers" :key="speaker.id">
                <div v-if="speaker.user_speaker" class="flex gap-1 items-center">
                  <div
                    :set="speakerInfo=speaker.user_speaker"
                    @click="goToProfile(speaker.user_speaker)"
                    class="cursor-pointer"
                    style="max-width: 32px"
                  >
                    <span
                      v-if="speakerInfo.avatar"
                      class="avatar avatar-sm avatar-rounded"
                      :style="
                        'background-image: url(' +
                        getImageURL(speakerInfo.avatar) +
                        ')'
                      "
                    ></span>
                    <span
                      v-if="!speakerInfo||!speakerInfo.avatar"
                      class="avatar avatar-sm avatar-rounded bg-pri text-white"
                    >
                      {{
                      speakerInfo.name.charAt(0) ||
                      speakerInfo.email.charAt(0)
                      }}
                    </span>
                  </div>
                  <span>{{ speakerInfo.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex gap-4">
            <div class="flex gap-2 items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 5.5H6.5V3.5C6.5 3.36739 6.44732 3.24021 6.35356 3.14645C6.25979 3.05268 6.13261 3 6 3C5.86739 3 5.74022 3.05268 5.64645 3.14645C5.55268 3.24021 5.5 3.36739 5.5 3.5V6C5.5 6.13261 5.55268 6.25979 5.64645 6.35355C5.74022 6.44732 5.86739 6.5 6 6.5H7.5C7.63261 6.5 7.75979 6.44732 7.85356 6.35355C7.94732 6.25979 8 6.13261 8 6C8 5.86739 7.94732 5.74021 7.85356 5.64645C7.75979 5.55268 7.63261 5.5 7.5 5.5ZM6 1C5.0111 1 4.0444 1.29324 3.22215 1.84265C2.39991 2.39206 1.75904 3.17295 1.3806 4.08658C1.00217 5.00021 0.90315 6.00555 1.09608 6.97545C1.289 7.94536 1.76521 8.83627 2.46447 9.53553C3.16373 10.2348 4.05465 10.711 5.02455 10.9039C5.99446 11.0969 6.99979 10.9978 7.91342 10.6194C8.82705 10.241 9.60794 9.6001 10.1573 8.77785C10.7068 7.95561 11 6.98891 11 6C11 5.34339 10.8707 4.69321 10.6194 4.08658C10.3681 3.47995 9.99983 2.92876 9.53554 2.46447C9.07124 2.00017 8.52005 1.63188 7.91342 1.3806C7.30679 1.12933 6.65661 1 6 1ZM6 10C5.20888 10 4.43552 9.7654 3.77772 9.32588C3.11992 8.88635 2.60723 8.26164 2.30448 7.53073C2.00173 6.79983 1.92252 5.99556 2.07686 5.21964C2.2312 4.44371 2.61216 3.73098 3.17158 3.17157C3.73099 2.61216 4.44372 2.2312 5.21964 2.07686C5.99557 1.92252 6.79983 2.00173 7.53074 2.30448C8.26164 2.60723 8.88635 3.11992 9.32588 3.77772C9.76541 4.43552 10 5.20887 10 6C10 7.06087 9.57858 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10Z"
                  fill="#20419B"
                />
              </svg>
              <span class="flex-1">{{ $t('conference.fm_minutes',{minutes:sessionData.duration}) }}</span>
            </div>
            <div class="flex gap-2 items-center">
              <svg
                class="mb-1"
                width="16"
                height="16"
                viewBox="0 0 10 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 9.5C5.09889 9.5 5.19556 9.47068 5.27779 9.41574C5.36001 9.36079 5.4241 9.2827 5.46194 9.19134C5.49978 9.09998 5.50969 8.99944 5.49039 8.90245C5.4711 8.80546 5.42348 8.71637 5.35355 8.64645C5.28363 8.57652 5.19454 8.5289 5.09755 8.50961C5.00055 8.49031 4.90002 8.50022 4.80866 8.53806C4.7173 8.5759 4.63921 8.63999 4.58427 8.72221C4.52932 8.80444 4.5 8.90111 4.5 9C4.5 9.13261 4.55268 9.25979 4.64645 9.35355C4.74021 9.44732 4.86739 9.5 5 9.5ZM7.5 9.5C7.59889 9.5 7.69556 9.47068 7.77779 9.41574C7.86001 9.36079 7.9241 9.2827 7.96194 9.19134C7.99978 9.09998 8.00969 8.99944 7.99039 8.90245C7.9711 8.80546 7.92348 8.71637 7.85355 8.64645C7.78363 8.57652 7.69454 8.5289 7.59755 8.50961C7.50056 8.49031 7.40002 8.50022 7.30866 8.53806C7.2173 8.5759 7.13921 8.63999 7.08426 8.72221C7.02932 8.80444 7 8.90111 7 9C7 9.13261 7.05268 9.25979 7.14645 9.35355C7.24021 9.44732 7.36739 9.5 7.5 9.5ZM7.5 7.5C7.59889 7.5 7.69556 7.47068 7.77779 7.41573C7.86001 7.36079 7.9241 7.2827 7.96194 7.19134C7.99978 7.09998 8.00969 6.99945 7.99039 6.90245C7.9711 6.80546 7.92348 6.71637 7.85355 6.64645C7.78363 6.57652 7.69454 6.5289 7.59755 6.50961C7.50056 6.49031 7.40002 6.50022 7.30866 6.53806C7.2173 6.5759 7.13921 6.63999 7.08426 6.72221C7.02932 6.80444 7 6.90111 7 7C7 7.13261 7.05268 7.25979 7.14645 7.35355C7.24021 7.44732 7.36739 7.5 7.5 7.5ZM5 7.5C5.09889 7.5 5.19556 7.47068 5.27779 7.41573C5.36001 7.36079 5.4241 7.2827 5.46194 7.19134C5.49978 7.09998 5.50969 6.99945 5.49039 6.90245C5.4711 6.80546 5.42348 6.71637 5.35355 6.64645C5.28363 6.57652 5.19454 6.5289 5.09755 6.50961C5.00055 6.49031 4.90002 6.50022 4.80866 6.53806C4.7173 6.5759 4.63921 6.63999 4.58427 6.72221C4.52932 6.80444 4.5 6.90111 4.5 7C4.5 7.13261 4.55268 7.25979 4.64645 7.35355C4.74021 7.44732 4.86739 7.5 5 7.5ZM8.5 1.5H8V1C8 0.867392 7.94732 0.740215 7.85355 0.646447C7.75979 0.552678 7.63261 0.5 7.5 0.5C7.36739 0.5 7.24021 0.552678 7.14645 0.646447C7.05268 0.740215 7 0.867392 7 1V1.5H3V1C3 0.867392 2.94732 0.740215 2.85355 0.646447C2.75979 0.552678 2.63261 0.5 2.5 0.5C2.36739 0.5 2.24021 0.552678 2.14645 0.646447C2.05268 0.740215 2 0.867392 2 1V1.5H1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3V10C0 10.3978 0.158035 10.7794 0.43934 11.0607C0.720644 11.342 1.10218 11.5 1.5 11.5H8.5C8.89782 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.60218 9.84196 2.22064 9.56066 1.93934C9.27936 1.65804 8.89782 1.5 8.5 1.5ZM9 10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H1.5C1.36739 10.5 1.24021 10.4473 1.14645 10.3536C1.05268 10.2598 1 10.1326 1 10V5.5H9V10ZM9 4.5H1V3C1 2.86739 1.05268 2.74021 1.14645 2.64645C1.24021 2.55268 1.36739 2.5 1.5 2.5H2V3C2 3.13261 2.05268 3.25979 2.14645 3.35355C2.24021 3.44732 2.36739 3.5 2.5 3.5C2.63261 3.5 2.75979 3.44732 2.85355 3.35355C2.94732 3.25979 3 3.13261 3 3V2.5H7V3C7 3.13261 7.05268 3.25979 7.14645 3.35355C7.24021 3.44732 7.36739 3.5 7.5 3.5C7.63261 3.5 7.75979 3.44732 7.85355 3.35355C7.94732 3.25979 8 3.13261 8 3V2.5H8.5C8.63261 2.5 8.75979 2.55268 8.85355 2.64645C8.94732 2.74021 9 2.86739 9 3V4.5ZM2.5 7.5C2.59889 7.5 2.69556 7.47068 2.77779 7.41573C2.86001 7.36079 2.9241 7.2827 2.96194 7.19134C2.99978 7.09998 3.00969 6.99945 2.99039 6.90245C2.9711 6.80546 2.92348 6.71637 2.85355 6.64645C2.78363 6.57652 2.69454 6.5289 2.59755 6.50961C2.50055 6.49031 2.40002 6.50022 2.30866 6.53806C2.2173 6.5759 2.13921 6.63999 2.08427 6.72221C2.02932 6.80444 2 6.90111 2 7C2 7.13261 2.05268 7.25979 2.14645 7.35355C2.24021 7.44732 2.36739 7.5 2.5 7.5ZM2.5 9.5C2.59889 9.5 2.69556 9.47068 2.77779 9.41574C2.86001 9.36079 2.9241 9.2827 2.96194 9.19134C2.99978 9.09998 3.00969 8.99944 2.99039 8.90245C2.9711 8.80546 2.92348 8.71637 2.85355 8.64645C2.78363 8.57652 2.69454 8.5289 2.59755 8.50961C2.50055 8.49031 2.40002 8.50022 2.30866 8.53806C2.2173 8.5759 2.13921 8.63999 2.08427 8.72221C2.02932 8.80444 2 8.90111 2 9C2 9.13261 2.05268 9.25979 2.14645 9.35355C2.24021 9.44732 2.36739 9.5 2.5 9.5Z"
                  fill="#20419B"
                />
              </svg>
              <span class="flex-1">{{ getDuration() }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="sessionData.file_schedule && sessionData.file_schedule.length" class="mt-4">
        <div
          v-for="file in sessionData.file_schedule"
          :key="file.id"
          class="flex mb-3 gap-2 items-center"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 10H10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10ZM9 12C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H9ZM20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16Z"
              fill="#20409B"
            />
          </svg>
          <a :href="file.url" target="_blank" class="cs-link">{{ file.name }}</a>
        </div>
      </div>
      <div class="flex flex-col gap-2 mt-4">
        <div class="font-bold fs-18">{{ $t('conference.lbl_summary') }}</div>
        <div>{{ getDataLang().abstract||'' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { LANGUAGE_CODES_FOR_DISEASE } from '@/lang'
import appUtils from '@/utils/appUtils'

export default {
  name: 'OverviewSessionConferenceDetail',
  data () {
    return {
      sessionData: {},
      isLoading: false,
      user_id: '',
      user_100ms_role: 'guest',
      selectedFeature: 'conference',
      circle: {}
    }
  },
  watch: {
    $route: {
      deep: true,
      handler () {
        this.getSessionDetail()
      }
    }
  },
  async created () {
    this.user_id = appUtils.getLocalUser().id
    await this.getSessionDetail()
    await this.showCircle()
    await this.get100msRole()
  },
  methods: {
    async getSessionDetail () {
      if (!this.$route.params?.sessionId && !this.$route.query?.sessionId) {
        return
      }

      try {
        this.isLoading = true
        const response = await this.$rf
          .getRequest('ConferenceRequest')
          .getConferenceSessionDetail(
            this.$route.params?.sessionId || this.$route.query?.sessionId
          )
        this.sessionData = response.data.circle_session_data || {}
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    getHeader () {
      const langValue = LANGUAGE_CODES_FOR_DISEASE[this.$lang.toUpperCase()]
      const langData =
        this.sessionData?.circle_info?.circle_language?.find(
          item => item?.Lang === langValue
        ) || {}
      return `${langData.name || ''} (${langData.location || ''})`
    },
    getDataLang () {
      const langValue = LANGUAGE_CODES_FOR_DISEASE[this.$lang.toUpperCase()]
      const langData =
        this.sessionData?.pape_multilanguage?.find(
          item => item?.lang === langValue
        ) || {}
      return langData
    },
    getImageURL (a) {
      return appUtils.getImageURL(a)
    },
    goToProfile (data) {
      const doctorId = data?.doctor_infor?.id
      if (!doctorId) return
      this.$router
        .push({ name: 'DoctorProfile', params: { id: doctorId } })
        .catch(() => {})
    },
    displayDuration (totalMinutes) {
      return this.$t('conference.fm_minutes', { minutes: totalMinutes })
    },
    getDuration () {
      return window
        .moment(this.sessionData.schedule_date)
        .format('DD/MM/YYYY HH:mm')
    },
    async get100msRole () {
      const circle_id =
        Number(this.circle?.id) ||
        Number(this.$route.params?.id) ||
        Number(this.sessionData?.circle_id) ||
        Number(this.$route.query?.id)
      await this.$rf
        .getRequest('DoctorRequest')
        .checkMyRoleConferenceRoom({
          circle_id,
          user_id: this.user_id
        })
        .then(res => {
          this.user_100ms_role =
            res.data?.one_hundred_ms_role ||
            JSON.stringify({
              conference: 'guest',
              livestream: 'viewer'
            })
        })
        .catch(e => {
          console.log(e)
          this.$toast.open({
            message: e,
            type: 'error'
          })
        })
    },
    async handleClickConference () {
      if (!this.circle?.one_hundred_ms_conf_id) return ''

      const { id, one_hundred_ms_conf_id } = this.circle
      await this.get100msRole().then(() => {
        let token = appUtils.getLocalToken()
        let dm = ''
        if (process.env.NODE_ENV === 'development') {
          dm = 'https://dev.live.hodo.app'
        } else {
          dm = 'https://live.hodo.app'
        }

        const roleObj = appUtils.isJSON(this.user_100ms_role)
          ? JSON.parse(this.user_100ms_role)
          : {
            [this.selectedFeature]: this.user_100ms_role
          }
        const role = roleObj[this.selectedFeature]
        const routeRaw = `${dm}/redirect.html?token=${token}&room_id=${one_hundred_ms_conf_id}&circle_id=${id}&type=conference&role=${role ||
          'guest'}`
        window.open(routeRaw, '_blank')
      })
    },
    async showCircle () {
      let self = this
      if (!this.$route.params.id) return
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .showCircle(this.$route.params.id)
        .then(r => {
          self.circle = { ...r.data }

          return r
        })
        .catch(e => {
          console.log(e)
          self.$toast.open({
            message: this.$t('circle_feature.lbl_permission_msg'),
            type: 'warning'
          })
          self.$router.push({ name: 'WorkspaceConference' }).catch(() => {})
          return false
        })
      return r?.data
    },
    getStatus (status) {
      switch (status) {
        case 1:
          return {
            text: this.$t('circle_feature.lbl_draft_schedule'),
            class: 'draft'
          }
        case 2:
          return {
            text: this.$t('circle_feature.lbl_public_schedule'),
            class: 'public'
          }
        case 3:
          return {
            text: this.$t('circle_feature.lbl_live_now'),
            class: 'ongoing'
          }
        default:
          return {
            text: this.$t('circle_feature.lbl_draft_schedule'),
            class: 'draft'
          }
      }
    },
    goToCircleDetail () {
      if (!this.$route.params?.id && !this.$route.query?.id) return

      this.$router
        .replace({
          name: 'WorkspaceConferenceDetail',
          params: {
            id: this.$route.params?.id || this.$route.query?.id
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.open-chat-att {
  display: flex;
  align-items: center;
  background-color: #fafafa;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 16px;
  position: relative;
  transition: all 0.3s ease;
  max-height: 60px;

  &:hover {
    background-color: #eff4ff;
  }
}

.cs-live {
  border: 3px solid #f04438;
  border-radius: 16px;
  padding: 6px;
  max-width: 140px;
  color: #f04438;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cs-link {
  text-decoration: underline;
  color: #20409b;
}

.title {
  &.labels {
    line-height: 21px;
  }
  span {
    display: inline-block;
    text-wrap: nowrap;
    border-radius: 15px;
    padding: 2px 10px;
  }
  .draft {
    background-color: rgb(0, 195, 255);
  }
  .public {
    background-color: #00b135;
  }
  .ongoing {
    background-color: red;
  }
}
</style>
